<template>
  <div>
    <template v-if="status && !refundVoidType">
      <div v-if="status == 'APPROVED'" class="text-success">
        {{ (amount / 100) | currency }}
      </div>

      <div v-if="status == 'DECLINED'" class="text-danger">
        <strike>{{ (amount / 100) | currency }}</strike>
      </div>
    </template>
    <template v-else-if="status && refundVoidType">
      <div v-if="refundVoidType == 'REFUNDED'" class="text-warning">
        {{ (amount / 100) | currency }}
      </div>
      <div v-if="refundVoidType == 'VOIDED'" class="text-muted">
        {{ (amount / 100) | currency }}
      </div>
    </template>
    <template v-else>
      {{ (amount / 100) | currency }}
    </template>
  </div>
</template>
<script>
export default {
  name: "transaction-amount",
  props: { amount: null, status: null, refundVoidType: null },
  data() {
    return {};
  },
};
</script>
<style scoped>
.disposition {
  font-size: 2em !important;
}
</style>
